import { useQuery } from "@tanstack/react-query";
import { fetchFilteredProducts } from "../services/api";

/**
 * Hook che restituisce (e cache-a) la pagina di prodotti filtrata.
 * - `keepPreviousData`: mantiene i dati precedenti finché non arriva la nuova pagina
 * - `enabled`: evita fetch quando mancano model_id, periodicity_id o customer_id
 */
export default function usePaginatedProducts(params) {
  return useQuery({
    queryKey: ["products", params],
    queryFn: () => fetchFilteredProducts(params),
    keepPreviousData: true,
    enabled: !!params.model_id && !!params.periodicity_id && !!params.customer_id,
  });
}